import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { BackbaseCoreModule, ItemModel } from '@backbase/foundation-ang/core';
import { BnSelectContextExtendedComponent } from './bn-select-context-extended.component';
import {
  AlertModule, EmptyStateModule,
  HeaderModule,
  InfiniteScrollModule,
  LoadingIndicatorModule,
  SearchBoxModule
} from "@backbase/ui-ang";
import { SelectContextWidgetModule } from "@backbase/select-context-widget-ang";
import {BnAppStateWidgetModule} from "bn-app-state-widget";
import { UserContextConfigurationToken } from 'user-context';
import { of } from 'rxjs';

const widgetProperties: { [key: string]: any } = {
  pageSize: 7,
  showSearchAfter: 5,
  includeCurrentContext: false,
  selectContextRedirectPage: "mpa:/index",
  back: "navigation-url:/login"
};
const itemModelStub = {
  properties: of({}),
  property: (key: string) => of(widgetProperties[key]),
};

@NgModule({
  declarations: [BnSelectContextExtendedComponent],
  imports: [
    CommonModule,
    BackbaseCoreModule.withConfig({
        classMap: {BnSelectContextExtendedComponent}
    }),
    HeaderModule,
    AlertModule,
    SearchBoxModule,
    InfiniteScrollModule,
    LoadingIndicatorModule,
    EmptyStateModule,
    SelectContextWidgetModule,
    BnAppStateWidgetModule
  ],
  providers: [
    {
      provide: UserContextConfigurationToken,
      useValue: '/',
    },
    {
      provide: ItemModel,
      useValue: itemModelStub
    },
  ],
  // schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports:[BnSelectContextExtendedComponent]
})
export class BnSelectContextExtendedModule { }
